import { Flex } from 'antd';
import styled from 'styled-components';

export const TimeDetailWrapper = styled(Flex)`
  background-color: var(--clr-container-bg);
  border-bottom: 1px solid var(--clr-border-grey-100);
  margin: calc(-1 * var(--spacing-gutter)) calc(-1 * var(--spacing-gutter)) 0;
  padding: var(--spacing-gutter);
  .icon {
    color: var(--clr-icon-color);
    font-size: 21px;
  }
`;
